import * as React from "react";
import { IconProps } from "./IconProps";

export const IconClipboard = React.forwardRef<SVGSVGElement, IconProps>(
  ({ color = "currentColor", ...props }, forwardedRef) => {
    return (
      <svg
        width="14"
        height="18"
        viewBox="0 0 14 18"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
        ref={forwardedRef}
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M3.66634 1.49984C3.66634 1.0396 4.03944 0.666504 4.49967 0.666504H9.49967C9.95991 0.666504 10.333 1.0396 10.333 1.49984V2.33317H12.833C13.2932 2.33317 13.6663 2.70627 13.6663 3.1665V16.4998C13.6663 16.9601 13.2932 17.3332 12.833 17.3332H1.16634C0.706104 17.3332 0.333008 16.9601 0.333008 16.4998V3.1665C0.333008 2.70627 0.706104 2.33317 1.16634 2.33317H3.66634V1.49984ZM5.33301 2.33317V3.99984H8.66634V2.33317H5.33301ZM10.333 3.99984V4.83317C10.333 5.29341 9.95991 5.6665 9.49967 5.6665H4.49967C4.03944 5.6665 3.66634 5.29341 3.66634 4.83317V3.99984H1.99967V15.6665H11.9997V3.99984H10.333Z"
          fill={color}
        />
      </svg>
    );
  },
);
